import { VBPopover } from './popover';
import { pluginFactory } from '../../utils/plugins';
var VBPopoverPlugin =
/*#__PURE__*/
pluginFactory({
  directives: {
    VBPopover: VBPopover
  }
});
export { VBPopoverPlugin, VBPopover };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/directives/popover/index.js
// module id = ./node_modules/bootstrap-vue/esm/directives/popover/index.js
// module chunks = 0 1